import React from "react";
import {Badge} from "react-bootstrap";
import CellInterface from "./CellInterface";

const CellAsTitle = ({value, type, element}: CellInterface) => {

    return (<>
        <div className={'cellAsVote'}>
            <h2>{value}</h2>
        </div>
    </>);
}

export default CellAsTitle;